import React, { lazy, Suspense } from 'react'
import { state } from 'cerebral/tags'
import { connect } from '@cerebral/react'
import MediaWrapper from 'components/Media/mediaWrapper'
import { StartPage } from 'components/StartPage'
import { css } from 'aphrodite'
import styles from './styles'

const views = [
  {
    key: 'media',
    view: MediaWrapper
  },
  {
    key: 'basket',
    view: lazy(() => import('../../Basket/basket'))
  },
  {
    key: 'startpage',
    view: StartPage
  },
  {
    key: 'orderHistory',
    view: lazy(() => import('../../OrderHistory/orderHistory'))
  },
  {
    key: 'upload',
    view: lazy(() => import('../../Upload/upload'))
  }
]

const CurrentView = connect(
  {
    currentView: state`app.currentView`,
    isMenuOpen: state`node.tree.open`,
    inMenuTransition: state`node.tree.transition`
  },
  ({ currentView, isMenuOpen, inMenuTransition }) => {
    const viewStyle = css(
      styles.container,
      isMenuOpen || (inMenuTransition && !isMenuOpen)
        ? styles.menuVisible
        : currentView === 'startpage' ? styles.menuNotVisible : styles.menuHover
    )

    const View = views.reduce((acc, view) => {
      if (view.key === currentView) {
        acc = view.view
      }
      return acc
    }, null)

    return (
      <div className={viewStyle}>
        <Suspense fallback={null}>
          <View />
        </Suspense>
      </div>
    )
  }
)

export default CurrentView



// WEBPACK FOOTER //
// ./src/components/App/CurrentView/currentView.js